import React, { useMemo } from "react";
import { useOrganization } from "../../context/OrganizationContext";
import { resolveOrgBranding } from "../../helpers/resolveOrgBranding";
import { ReportBrandBlock } from "./ReportBrandBlock";
import { ReportHeaderFields } from "./ReportHeaderFields";
import { ReportRule } from "./ReportRule";
import "./ReportBrandBlock.css";
import "./ReportHeaderLayout.css";

function ReportHeaderInfoPanel({ variant, panelTitle, fields }) {
  if (!fields?.length) return null;

  const isPrint = variant === "print";
  const panelClass = isPrint ? "erp-info-panel" : "er-info-panel";
  const titleClass = isPrint ? "erp-panel-title" : "er-panel-title";

  return (
    <section className={panelClass}>
      <h2 className={titleClass}>{panelTitle}</h2>
      <ReportHeaderFields fields={fields} variant={variant} />
    </section>
  );
}

/**
 * @param {{
 *   variant?: "print" | "preview",
 *   docTitle: string,
 *   panelTitle?: string,
 *   fields?: Array<{ label: string, value: string }>,
 *   branding?: import("../../helpers/resolveOrgBranding").OrgBrandingSnapshot,
 * }} props
 */
export function ReportHeader({
  variant = "print",
  docTitle,
  panelTitle,
  fields,
  branding: brandingOverride,
}) {
  const { settings } = useOrganization();
  const branding = useMemo(
    () => brandingOverride ?? resolveOrgBranding(settings),
    [brandingOverride, settings],
  );

  if (variant === "print") {
    return (
      <div className="erp-header-block">
        <header className="erp-report-header">
          <ReportBrandBlock
            branding={branding}
            variant="print"
            docTitle={docTitle}
          />
        </header>

        <ReportRule variant="print" />
        <ReportHeaderInfoPanel
          variant="print"
          panelTitle={panelTitle}
          fields={fields}
        />
      </div>
    );
  }

  return (
    <div className="er-header-block">
      <ReportBrandBlock
        branding={branding}
        variant="preview"
        docTitle={docTitle}
      />
      <ReportRule variant="preview" />
      <ReportHeaderInfoPanel
        variant="preview"
        panelTitle={panelTitle}
        fields={fields}
      />
    </div>
  );
}
